import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_QUICKBOOKS_ITEMS = `${ACCOUNT_SERVICE}/qbo-items`;

export const quickBooksItems = {
  getAll: async () => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS_ITEMS}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  getCustomFields: async () => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS_ITEMS}/custom-fields`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  test: async () => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS_ITEMS}/test`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
};
